import React from "react"
import { getConnectionType, NodeCaption, NodeWindow, NodeContent, NodeWrapper, HandleInput, HandleOutputWrapper } from "../";


export const NodeSticky = React.memo((props) => {

  const { id, data } = props;
  const { bgColor = "#f9f967", fontColor = "black", anotacion, nombre, onEdit, onRemove } = data;
  
  return (
    <NodeWrapper bgColor={bgColor}>
      <NodeWindow 
        caption={
          <NodeCaption fontColor={fontColor} title={nombre} onClickEdit={()=>onEdit(props)} onClickRemove={()=>onRemove(props)}/>
        }
      >
        {anotacion && 
          <NodeContent fontColor={fontColor}>
            {anotacion}
          </NodeContent>
        }
      </NodeWindow>
    </NodeWrapper>
  );
});


